import React from 'react';
import { Card, CardContent } from '../ui/card';
import { ShieldCheck, CheckCircle, ArrowSquareOut } from '@phosphor-icons/react';

export function AdminEmailsTab({ emailConfig }) {
  return (
    <div className="space-y-3" data-testid="emails-tab">
      {emailConfig ? (
        <>
          <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-lg p-3 text-xs text-emerald-700">
            <ShieldCheck size={16} weight="fill" />
            Les emails transactionnels sont geres automatiquement par Stripe.
          </div>
          {emailConfig.emails.map(em => (
            <Card key={em.type} className="border" data-testid={`email-${em.type}`}>
              <CardContent className="p-4 flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                  <CheckCircle size={20} className="text-emerald-500 flex-shrink-0" weight="fill" />
                  <div className="min-w-0">
                    <p className="text-sm font-bold text-[#111827]">{em.label}</p>
                    <p className="text-xs text-[#6B7280]">{em.description}</p>
                  </div>
                </div>
                <span className="text-[10px] bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded font-bold flex-shrink-0">Actif</span>
              </CardContent>
            </Card>
          ))}
          <a href={emailConfig.dashboard_url} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-xs text-[#FF6B00] hover:underline mt-1 font-medium"
            data-testid="stripe-dashboard-link">
            Configurer dans Stripe Dashboard <ArrowSquareOut size={14} />
          </a>
        </>
      ) : (
        <p className="text-sm text-[#6B7280]">Configuration non disponible.</p>
      )}
    </div>
  );
}
